import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {getProgramFormat} from '../data/programFormats';

const {FiChevronDown, FiCheck, FiMapPin} = FiIcons;

function ProgramAccordion({program, isOpen, onToggle}) {
  const format = getProgramFormat(program.name);

  return (
    <article className={`program-card ${isOpen ? 'open' : ''}`}>
      <button
        className="program-trigger"
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={`program-details-${program.name}`}
      >
        <span>
          <strong>{program.name}</strong>
          <small>{program.badge}</small>
        </span>
        <SafeIcon icon={FiChevronDown} className="chevron" aria-hidden="true" />
      </button>

      <motion.div
        className="program-content"
        id={`program-details-${program.name}`}
        initial={false}
        animate={{
          height: isOpen ? 'auto' : 0,
          opacity: isOpen ? 1 : 0
        }}
        transition={{duration: 0.3, ease: 'easeInOut'}}
        style={{overflow: 'hidden'}}
      >
        <div className="program-inner">
          <p className="program-summary">{program.summary}</p>

          <div
            className="spec-table"
            role="table"
            aria-label={`${program.name} details`}
          >
            <div className="spec-row" role="row">
              <span role="cell">Program format</span>
              <strong role="cell">{format}</strong>
            </div>

            {program.specs.map(([label, value]) => (
              <div className="spec-row" role="row" key={label}>
                <span role="cell">{label}</span>
                <strong role="cell">{value}</strong>
              </div>
            ))}
          </div>

          {program.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}

          <ul className="highlight-list">
            {program.highlights.map((item) => (
              <li key={item}>
                <SafeIcon icon={FiCheck} />
                {item}
              </li>
            ))}
          </ul>

          <div className="location-title">
            <SafeIcon icon={FiMapPin} />
            <span>{program.address}</span>
          </div>

          <iframe
            className="map"
            src={program.mapEmbedUrl}
            width="600"
            height="450"
            style={{border: 0}}
            title={`Google Maps listing for ${program.name}`}
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </div>
      </motion.div>
    </article>
  );
}

export default ProgramAccordion;